import { HistoryViewModel } from '../../support/HistoryViewModel';
import { IDrawerQueryParams } from './IDrawerQueryParams';

export class QueryParamDrivenDrawerHelper<TDrawerProps = {}>{
    static inject = () => [HistoryViewModel];
    constructor(private history: HistoryViewModel){}

    getUrl = (params: IDrawerQueryParams & TDrawerProps) => {
        const path = this.history.getCurrentLocation().pathname;

        const searchParams = this.history.getCurrentSearchParams();

        const drawerSearchParams = this.buildQueryParams(params);
        for (const key of drawerSearchParams.keys()){
            searchParams.set(key, drawerSearchParams.get(key)!);
        }

        return `${path}?${searchParams.toString()}`;
    };

    open = (params: IDrawerQueryParams & TDrawerProps) => {
        this.history.push(this.getUrl(params));
    };

    buildQueryParams = (params: IDrawerQueryParams & TDrawerProps) => {
        const searchParams = new URLSearchParams();
        searchParams.set('drawer', JSON.stringify(params));
        return searchParams;
    };

    getDrawerParams= () => {
        const drawerParam = this.history.getCurrentSearchParamMap().drawer || '{}';
        return JSON.parse(drawerParam);
    };

    close = () => {
        const path = this.history.getCurrentLocation().pathname;
        const searchParams = this.history.getCurrentSearchParams();
        searchParams.delete('drawer');

        this.history.push(`${path}?${searchParams.toString()}`);
    };

    closeAndRedirect = (redirectPath: string) => {
        this.close();
        setTimeout(() => this.history.push(redirectPath), 350);
    };
};
